module.exports = __webpack_public_path__ + "static/media/flight-arrival.9ce43a40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flight-arrival.svg
// module id = 701
// module chunks = 0